<!--新闻通用预览弹窗-->
<template>

  <el-dialog v-dialogDrag :visible.sync="dialogVisible" width="55rem" :title="data.title">
    <div class="newContent">
      <div class="time">
        <!-- <span>信息来源：腾讯新闻</span> -->
        <span>发布日期：{{data.time}}</span>
      </div>
      <div v-html="data.content" class="text">

      </div>
    </div>
  </el-dialog>

</template>

<script>
export default {
  data() {
    return {
      data: {
        title: '',
        time: '',
        content: '',
      },
      dialogVisible: false,
    }
  },
  methods: {
    dialog(data) {
      this.data = data
      this.dialogVisible = true
    },
  },
  mounted() {},
}
</script>

<style lang="less" scoped>
.newContent {
  .time {
    margin: 0 0 15px;
    span {
      display: inline-block;
      width: 20%;
    }
  }
  .text {
    line-height: 1rem;
    min-height: 10rem;
    img {
      max-width: 100%;
    }
  }
}
</style>